export default "__VITE_PUBLIC_ASSET__9d30b172__"